import { getExpressAccounts, getExpressContacts } from "../../services/expressMaster";
import {
  ExpressAccount,
  ExpressContact,
  ExpressContactKind,
} from "../../types/express-master.type";

/** How many codes one search offers; typing more of the code or name narrows it. */
const PICKER_SEARCH_LIMIT = 20;

/** The pickers offer active codes only: a code switched off stays on old documents but not new ones. */
const activeSearchParams = (text: string) => ({
  page: 1,
  limit: PICKER_SEARCH_LIMIT,
  search: text || undefined,
  is_active: true,
});

export const searchActiveAccounts = async (text: string): Promise<ExpressAccount[]> => {
  const {
    data: { data },
  } = await getExpressAccounts(activeSearchParams(text));
  return data?.rows ?? [];
};

const searchActiveContacts =
  (kind: ExpressContactKind) =>
  async (text: string): Promise<ExpressContact[]> => {
    const {
      data: { data },
    } = await getExpressContacts({ ...activeSearchParams(text), kind });
    return data?.rows ?? [];
  };

/** One search per kind, made once, so a picker's search does not change between renders. */
export const SEARCH_ACTIVE_CONTACTS: Record<ExpressContactKind, (text: string) => Promise<ExpressContact[]>> = {
  SUPPLIER: searchActiveContacts("SUPPLIER"),
  CUSTOMER: searchActiveContacts("CUSTOMER"),
};
